export class LegalEntityPracticeStateModel {
  loading: boolean;

  static get empty(): LegalEntityPracticeStateModel {
    return {
      loading: false
    };
  }
}

export class LegalEntityDocumentAttachment {
  documentId = '';
  fileName = '';
  downloadLink = '';
}

